import { render, staticRenderFns } from "./AtualizarCadastro.vue?vue&type=template&id=fbebe24e"
import script from "./AtualizarCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizarCadastro.vue?vue&type=script&lang=js"
import style0 from "./AtualizarCadastro.vue?vue&type=style&index=0&id=fbebe24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports